// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
  font-size: 1em !important;
}

.container-exam-evaluation {
  font-weight: bold;
  line-height: 1.42857143;
  padding: 9px 17px 0px;
  color: #0094ce;
  font-weight: bold;
}

.table-evaluation {
  padding: 12px 17px 0px;
  text-align: center;
  margin: 23px auto;
}

.border-1 {
  border: 1px solid;
  margin-top: -1px;
}

.table-eval {
  padding: 10px 15px 10px 27px;
  text-align: center;
  color: #0094ce;
  font-weight: bold;
  width: 120%;
}

.table-eval div div {
  font-size: 90%;
  border: 1px solid;
  margin-top: -1px;
  min-width: 20%;
}

.table-eval div.input {
  padding-left: 8px;
}

.table-eval .tale-head div:first-child {
  border-top-left-radius: 15px;
}

.table-eval .tale-head div:last-child {
  border-top-right-radius: 15px;
}

.table-eval .table-body:last-child div:last-child {
  border-bottom-right-radius: 15px;
}

.table-eval .table-body:last-child div:first-child {
  border-bottom-left-radius: 15px;
}

.width-100 {
  width: 100%;
}

.height-1 {
  min-height: 31px !important;
}

.padding-6 {
  padding: 6px;
}

.padding-3 {
  padding: 3px;
}

.display-flex {
  display: flex;
}

.exam-item-evaluation {
  background-color: white;
  padding-left: 8px;
}

.exam-item-evaluation.empty,
.exam-item-evaluation.readOnly {
  background-color: rgb(238, 238, 238);
}

.restExt {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.42857143;
  color: #0094ce;
  padding: 5px 38px 11px 15px;
  font-weight: bold;
  margin-top: 6px;
}

input,
input:active,
input:focus,
input:focus-within,
input:target,
input:hover,
input:visited,
input:focus-visible,
textarea,
textarea:active,
textarea:focus,
textarea:focus-within,
textarea:target,
textarea:hover,
textarea:visited,
textarea:focus-visible,
select,
select:active,
select:focus,
select:focus-within,
select:target,
select:hover,
select:visited,
select:focus-visible {
  border-color: #0094ce;
  border: 2px solid;
}

.enunciado {
  padding-left: 13px;
  padding-right: 7px;
}

.input-extend {
  border-color: #0094ce;
  border: 2px solid;
  padding-left: 8px;
}

.select-remat {
  font-size: 12px;
}

.exam-item-evaluation {
  height: 100%;
  width: 100%;
}

.exam-item-evaluation.error {
  border-color: red;
}

.text-area-legend {
  position: relative;
  top: -31px;
  width: 88px;
  left: 88%;
  font-size: 85%;
}

@media screen and (max-width: 1244px) {
  .table-evaluation,
  .table-eval,
  .enunciado,
  .restExt {
    font-size: 80%;
  }
  .border-1 {
    height: 36px;
  }
}

/* Estilos para el textarea de notas rápidas */
#modalQuickNotes textarea {
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: Arial, sans-serif;
  line-height: 1.5;
  transition: border-color 0.3s;
}

#modalQuickNotes textarea:focus {
  outline: none;
  border-color: #0094ce;
  box-shadow: 0 0 5px rgba(0, 148, 206, 0.3);
}

#modalQuickNotes .modal-footer {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/exam-evaluation-conf/exam-evaluation-conf.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,2DAA2D;EAC3D,uBAAuB;EACvB,cAAc;EACd,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;;;;IAIE,cAAc;EAChB;EACA;IACE,YAAY;EACd;AACF;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB","sourcesContent":["section {\r\n  font-size: 1em !important;\r\n}\r\n\r\n.container-exam-evaluation {\r\n  font-weight: bold;\r\n  line-height: 1.42857143;\r\n  padding: 9px 17px 0px;\r\n  color: #0094ce;\r\n  font-weight: bold;\r\n}\r\n\r\n.table-evaluation {\r\n  padding: 12px 17px 0px;\r\n  text-align: center;\r\n  margin: 23px auto;\r\n}\r\n\r\n.border-1 {\r\n  border: 1px solid;\r\n  margin-top: -1px;\r\n}\r\n\r\n.table-eval {\r\n  padding: 10px 15px 10px 27px;\r\n  text-align: center;\r\n  color: #0094ce;\r\n  font-weight: bold;\r\n  width: 120%;\r\n}\r\n\r\n.table-eval div div {\r\n  font-size: 90%;\r\n  border: 1px solid;\r\n  margin-top: -1px;\r\n  min-width: 20%;\r\n}\r\n\r\n.table-eval div.input {\r\n  padding-left: 8px;\r\n}\r\n\r\n.table-eval .tale-head div:first-child {\r\n  border-top-left-radius: 15px;\r\n}\r\n\r\n.table-eval .tale-head div:last-child {\r\n  border-top-right-radius: 15px;\r\n}\r\n\r\n.table-eval .table-body:last-child div:last-child {\r\n  border-bottom-right-radius: 15px;\r\n}\r\n\r\n.table-eval .table-body:last-child div:first-child {\r\n  border-bottom-left-radius: 15px;\r\n}\r\n\r\n.width-100 {\r\n  width: 100%;\r\n}\r\n\r\n.height-1 {\r\n  min-height: 31px !important;\r\n}\r\n\r\n.padding-6 {\r\n  padding: 6px;\r\n}\r\n\r\n.padding-3 {\r\n  padding: 3px;\r\n}\r\n\r\n.display-flex {\r\n  display: flex;\r\n}\r\n\r\n.exam-item-evaluation {\r\n  background-color: white;\r\n  padding-left: 8px;\r\n}\r\n\r\n.exam-item-evaluation.empty,\r\n.exam-item-evaluation.readOnly {\r\n  background-color: rgb(238, 238, 238);\r\n}\r\n\r\n.restExt {\r\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n  line-height: 1.42857143;\r\n  color: #0094ce;\r\n  padding: 5px 38px 11px 15px;\r\n  font-weight: bold;\r\n  margin-top: 6px;\r\n}\r\n\r\ninput,\r\ninput:active,\r\ninput:focus,\r\ninput:focus-within,\r\ninput:target,\r\ninput:hover,\r\ninput:visited,\r\ninput:focus-visible,\r\ntextarea,\r\ntextarea:active,\r\ntextarea:focus,\r\ntextarea:focus-within,\r\ntextarea:target,\r\ntextarea:hover,\r\ntextarea:visited,\r\ntextarea:focus-visible,\r\nselect,\r\nselect:active,\r\nselect:focus,\r\nselect:focus-within,\r\nselect:target,\r\nselect:hover,\r\nselect:visited,\r\nselect:focus-visible {\r\n  border-color: #0094ce;\r\n  border: 2px solid;\r\n}\r\n\r\n.enunciado {\r\n  padding-left: 13px;\r\n  padding-right: 7px;\r\n}\r\n\r\n.input-extend {\r\n  border-color: #0094ce;\r\n  border: 2px solid;\r\n  padding-left: 8px;\r\n}\r\n\r\n.select-remat {\r\n  font-size: 12px;\r\n}\r\n\r\n.exam-item-evaluation {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.exam-item-evaluation.error {\r\n  border-color: red;\r\n}\r\n\r\n.text-area-legend {\r\n  position: relative;\r\n  top: -31px;\r\n  width: 88px;\r\n  left: 88%;\r\n  font-size: 85%;\r\n}\r\n\r\n@media screen and (max-width: 1244px) {\r\n  .table-evaluation,\r\n  .table-eval,\r\n  .enunciado,\r\n  .restExt {\r\n    font-size: 80%;\r\n  }\r\n  .border-1 {\r\n    height: 36px;\r\n  }\r\n}\r\n\r\n/* Estilos para el textarea de notas rápidas */\r\n#modalQuickNotes textarea {\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-family: Arial, sans-serif;\r\n  line-height: 1.5;\r\n  transition: border-color 0.3s;\r\n}\r\n\r\n#modalQuickNotes textarea:focus {\r\n  outline: none;\r\n  border-color: #0094ce;\r\n  box-shadow: 0 0 5px rgba(0, 148, 206, 0.3);\r\n}\r\n\r\n#modalQuickNotes .modal-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 10px 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
